import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import CommonLayout from "../common/CommonLayout";
import Home from "../component/Home";

const Routing = () => {
  return (
    <Router basename="/teams">
      <Routes>
        <Route
          path="/"
          element={<CommonLayout>{<Home />}</CommonLayout>}
        ></Route>
      
      </Routes>
    </Router>
  );
};

export default Routing;
